


// api.js

// export const callApi = (url, method, headers, body) => {
//     return fetch(url, {
//         method: method,
//         headers: headers,
//         body: JSON.stringify(body)
//     })
//     .then(response => {
//         if (!response.ok) {
//             throw new Error('Network response was not ok');
//         }
//         return response.json();
//     })
//     .catch(error => {
//         throw new Error('There was a problem with the fetch operation:', error);
//     });
// };


export const callApi = (url, method, headers, body) => {
    return fetch(url, {
        method: method,
        headers: headers,
        body: body ? JSON.stringify(body) : null,
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .catch(error => {
        console.error('Fetch error:', error);

        // Redirect to error page
         window.location.href = '/api-error';

        // Optional: return a rejected promise if needed elsewhere
        return Promise.reject(error);
    });
};





